import React from 'react'

import { useDocumentStore } from '@/features/document'
import { ResponseDocumentVersion } from '@/schema'

type TUseGetVersionListProps = {
  documentId?: string | null
}

type TUseGetVersionListReturn = {
  versions: ResponseDocumentVersion[]
}

/**
 * Hook to get the list of versions for a document
 * @param props - The props for the hook
 * @returns The list of versions
 */
export const useGetVersionList = (
  props: TUseGetVersionListProps
): TUseGetVersionListReturn => {
  const { documentId } = props
  const { listVersionByDocumentId, getListVersion } = useDocumentStore()

  const versions = React.useMemo(
    () => (documentId ? getListVersion(documentId) : []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getListVersion, documentId, listVersionByDocumentId]
  )
  return { versions }
}
